import { useMemo, useState } from 'react';
import SectionHeading from '@/components/feature/SectionHeading';
import { recommendations, recFilters } from '@/mocks/drama';

export default function Recommendations() {
  const [filter, setFilter] = useState('全部');

  const list = useMemo(
    () =>
      filter === '全部'
        ? recommendations
        : recommendations.filter((item) => item.tags.includes(filter)),
    [filter],
  );

  return (
    <section id="recommend" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="You may also like"
          title="类似伦理题材作品推荐"
          desc="下面这些题材方向，与《继母的诱惑》在关系结构、叙事节奏或主题表达上有相通之处。点击标签即可筛选。"
        />

        <div className="mt-8 flex flex-wrap gap-2">
          {recFilters.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => setFilter(tag)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm font-label transition-colors ${
                filter === tag
                  ? 'bg-primary-500 text-background-50'
                  : 'border border-background-200 bg-background-100 text-foreground-600 hover:border-primary-300 hover:text-primary-600'
              }`}
            >
              {tag}
            </button>
          ))}
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((item) => (
            <article
              key={item.title}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-100"
            >
              <div className="relative h-64 w-full overflow-hidden">
                <img
                  src={item.cover}
                  alt={`${item.title} 封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-background-50/90 px-2.5 py-1 text-xs font-label font-medium text-primary-700">
                  {item.type}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs font-label text-foreground-500">{item.meta}</p>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.similar}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-label text-secondary-900"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>

        {list.length === 0 && (
          <p className="mt-10 rounded-lg border border-background-200 bg-background-100 p-8 text-center text-sm text-foreground-500">
            该标签下暂无推荐，试试切换其他标签。
          </p>
        )}

        <p className="mt-8 text-xs leading-relaxed text-foreground-500">
          注：以上条目为按题材方向整理的同类作品参考，用于帮助你按口味继续挑选，具体内容请以实际播出或出版信息为准。
        </p>
      </div>
    </section>
  );
}